export default function and<T>(predicates: Predicate<T>[]) {
  return function _and(val: T): boolean {
    return predicates.every((p) => p(val));
  };
}
